 // if($('#hideOtherImages').val() == "true"){
$('input[name="Color"]').change(function(){
      var color=$(this).val();
      var slide_count = 1;
      $('.product__media.media img').each(function(){
        var altTag=$(this).attr('alt');
        if (altTag.indexOf(color) > -1) {
          $(this).parents('.product__media-item').show();
       if(slide_count == 1){
          $(this).parents('.product__media-item').addClass('slide-active first-slide');
          slide_count = slide_count + 1;
          }else{
          $(this).parents('.product__media-item').addClass('slide-active');
          }
        }else{
          $(this).parents('.product__media-item').hide();
          $(this).parents('.product__media-item').removeClass('slide-active');
           $(this).parents('.product__media-item').removeClass('slide-active first-slide');
        }
      });

      $('.product-media-modal.media-modal .product-media-modal__content img').each(function(){
        let altTag=$(this).attr('alt');
        if (altTag.indexOf(color) > -1) {
          $(this).show();            
        } else{
          $(this).hide();          
        }
      });
  
      if ($(window).width() < 768) {
      $('.dots .thumbnail-list__item').each(function(){
        var altTag2=$(this).data('alt');
        if (altTag2.indexOf(color) > -1) {
//           alert(altTag2);
          $(this).show();
        }else{
//           alert("2 + " +altTag2);
          $(this).hide();
        }
      });
    }
    });
 // }
 setTimeout(function(){
$(document).ready(function(){
  if($('#selectedVariant').val() == 'false'){
    var options=($('#firstAvailable').val()).split(' / ');
    $('input[name="Color"][value="'+options[0]+'"]').trigger('click');
    $('input[name="Size"][value="'+options[1]+'"]').trigger('click');
  }
  // if($('#hideOtherImages').val() == "true"){
  //   var color=$('input[name="Color"]').val();
  //   $('.product__media.media img').each(function(){
  //     var altTag=$(this).attr('alt');
  //     if (altTag.indexOf(color) > -1) {
  //       $(this).parents('.product__media-item').show();
  //     }else{
  //       $(this).parents('.product__media-item').hide();
  //     }
  //   });
  // }
  $('.sticky_cart-btn').click(function(){
    $('.product-form__buttons .product-form__submit').trigger('click');
  });
});
},1000 );